module.exports = __webpack_public_path__ + "static/media/033.3e1ea335.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/people/normals/033.jpg
// module id = 329
// module chunks = 0